import styled from "styled-components";
import { COLORS, responsive } from "../../../styles/constants.style";

export const ViewProfileWrapper = styled.div`
  .separator-space {
    border-bottom: 1px dashed ${COLORS.primary_light_blue4};
  }

  .view-profile-container {
    margin: 0px 16px 24px 16px;
    ${responsive.MOBILE`
      margin: 0 8px 16px 8px;`}
  }
`;
